import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

function DeleteColumn({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DATA-TABLE.DELETE-COLUMN.';
    const [tab, setTab] = useState(action.fields.type?.value ? action.fields.type.value : 'name');
    useEffect(() => {
        // Assign initial values
        if (!action.fields.type) { action.fields.type = { value: 'name' }; }
    }, []);
    // Handle tab click
    const handleClick = (e) => {
        let value = e.target.value;
        action.fields.type.value = value;
        setTab(value);
    }
    return (
        <div>
            <div className="form-element">
                {t(label + 'SOURCE')}
                <VariablePicker action={action} inputName="assignSource" variables={variables} setOpenVariable={setOpenVariable} filter="data table" isRequired />
                <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
            </div>
            <div className="condition-tabs">
                <button className={tab === 'name' ? 'condition-active' : ''} value="name" onClick={handleClick}>
                    {t(label + 'NAME')}
                </button>
                <button className={tab === 'index' ? 'condition-active' : ''} value="index" onClick={handleClick}>
                    {t(label + 'INDEX')}
                </button>
            </div>
            {tab === 'name' ? <div className='form-element'>
                {t(label + 'NAMES')}
                <TextInput action={action} inputName="name" variables={variables} setOpenVariable={setOpenVariable} isRequired />
            </div> :
                <div className='form-element'>
                    {t(label + 'INDEXES')}
                    <TextInput action={action} inputName="index" variables={variables} setOpenVariable={setOpenVariable} isRequired />
                </div>
            }
        </div>
    );
}
export default DeleteColumn;